import capterra from '@public/images/signup/capterra.webp';
import GetApp from '@public/images/signup/GetApp.webp';
import mid_market_high_performer from '@public/images/signup/high_performer_mid_market.webp';
import high_performer_small_business from '@public/images/signup/high_performer_small_business.webp';
import emea_high_performer from '@public/images/signup/high_performer_social_media_suite_emea.webp';
import europe_high_performer from '@public/images/signup/high_performer_social_media_suite_europe.webp';
import highest_user_adaptation from '@public/images/signup/highest_user_adoption.webp';
import softwareadvice from '@public/images/signup/softwareadvice.webp';

export const reassuranceLogos = [
    {
        image: capterra,
        alt: 'Capterra'
    },
    {
        image: softwareadvice,
        alt: 'Software Advice'
    },
    {
        image: GetApp,
        alt: 'GetApp'
    }
];

export const reassuranceLogosAwards = [
    {
        image: high_performer_small_business,
        alt: 'High Performer Small Business'
    },
    {
        image: highest_user_adaptation,
        alt: 'Social Media Suites Highest User Adaptation'
    },
    {
        image: europe_high_performer,
        alt: 'Social Media Suites High Performer Europe'
    },
    {
        image: emea_high_performer,
        alt: 'Social Media Suites High Performer EMEA'
    },
    {
        image: mid_market_high_performer,
        alt: 'Social Media Suites High Performer Mid Market'
    }
];
